import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-sav',
  templateUrl: './sav.component.html',
  styleUrls: ['./sav.component.scss']
})
export class SavComponent implements OnInit {
  mess:any = {};

  type:string = 'part';

  editors:any = [];
  
  editorsNoFormat:any;

  games:any;

  sended = false;

  formData:any;

  fileLoading = false;
  fileError;

  arrayOne(n: number): any[] {
    return Array(n);
  }

  constructor(public api:ApiService, private http: HttpClient) { }

  ngOnInit() {
    this.api.get("site=getEditeurs").then((res:any)=>{
      this.editorsNoFormat = res.editors;
      for(let editor of res.editors){
        this.editors.push({label:editor.name_editor,value:editor.name_editor});
      }
    });
  }

  filterGames(){
    this.games = [];
    let editors = [];
    for(let editor of this.editorsNoFormat){
      if(editor.name_editor == this.mess.editor)
        editors.push(editor.id_editor);
    }
    this.api.post("site=filterJeux",{editors:editors}).then((res:any)=>{
      for(let jeu of res.jeux){
        this.games.push({label:jeu.name_item,value:jeu.name_item});
      }
    });
  }

  send(){
    this.api.post("site=sav",this.mess).then((res:any)=>{
      if(res = 'ok')
        this.sended = true;
      else
        this.api.error('Une erreur a eu lieu');
    });
  }

  onUploadOutput(event){
    this.fileLoading = true;
    const file:File = event.target.files[0];

    this.formData = new FormData();
    this.formData.append("file", file); 
    const upload$ = this.http.post("https://blackrockgames.fr/upload/index.php?sav", this.formData);
    upload$.subscribe((res)=>{
      if(res['statut'] == 'ok'){
        this.mess.file = res['src'];
      }else{
        this.fileError = res['message'];
      }
      this.fileLoading = false;
    },err=>{
      this.fileLoading = false;
      this.fileError = "Une erreur a eu lieu";

    });
  }
}
